<template>
  <el-scrollbar style="height:100%;" wrap-class="default-scrollbar__wrap">
    <div>
      <div class="js-home home-container app-container">
        <el-row>
          <div class="home-left">
            <el-col :span="9">
              <!--地图Map carlist-->
              <el-row :span="23">
                <div class="map-car-list l1">
                  <el-col :span="6" class="list-center">
                    <span class="in-car-word text-center">Park Engine Off</span>
                    <span class="in-car-number text-center">{{vehicleStatus.parkingEngineOff}}</span>
                    <img src="../../assets/parkingEngineOff.png" class="img-center" />
                  </el-col>
                  <el-col :span="6" class="list-center">
                    <span class="in-car-word text-center">Park Engine On</span>
                    <span class="in-car-number text-center">{{vehicleStatus.parkingEngineOn}}</span>
                    <img src="../../assets/parkingEngineOn.png" class="img-center" />
                  </el-col>
                  <el-col :span="6" class="list-center">
                    <span class="in-car-word text-center">Normal Speed</span>
                    <span class="in-car-number text-center">{{vehicleStatus.normalspeed}}</span>
                    <img src="../../assets/normalspeed.png" class="img-center" />
                  </el-col>
                  <el-col :span="6" class="list-center">
                    <span class="in-car-word text-center">Over Speed</span>
                    <span class="in-car-number text-center">{{vehicleStatus.overSpeed}}</span>
                    <img src="../../assets/overspeed.png" class="img-center" />
                  </el-col>
                </div>
              </el-row>
              <!--地图-->
              <el-row class="map-tha">
                <vue-map
                  :map-type-control="true"
                  :center="center"
                  :zoom="zoom"
                  :language="language"
                  :events="mapEvents"
                  :disable-default-ui="true"
                >
                  <div class="over-speed">
                    <el-popover width="220" v-model="speedVisible">
                      <span style="display:inline-block;width: 83px;">Speed Limit:</span>
                      <el-input-number v-model="tempSpeed" :precision="0" @change="changeSpeed" step-strictly />
                      <div
                        style="text-align: right; margin: 0; margin-top: 5px; margin-right: 7px;}"
                      >
                        <el-button
                          type="text"
                          @click="tempSpeed=maxSpeed;speedVisible=false"
                        >{{$t("el.messagebox.cancel")}}</el-button>
                        <el-button
                          type="primary"
                          @click="maxSpeed=tempSpeed;speedVisible=false"
                        >{{$t("el.messagebox.confirm")}}</el-button>
                      </div>
                      <el-button
                        size="medium"
                        circle
                        type="danger"
                        slot="reference"
                        title="Speed Limit"
                      >{{maxSpeed}}</el-button>
                    </el-popover>
                  </div>
                  <vue-map-marker
                    v-for="v in vehicles"
                    :icon="v.icon"
                    :position="v.position"
                    :visible="v.visible"
                    :key="v.id"
                    :vehicle="v"
                    :events="vehicleMarkerEvents"
                  />
                  <vue-map-info-window
                    :offset="vehicleInfoWindowOffset"
                    :position="infoWindowPosition"
                    :visible="visible"
                  >
                    <car-info :id="carid" @close="visible=false" />
                  </vue-map-info-window>
                </vue-map>
              </el-row>
            </el-col>
          </div>
          <el-col :span="15">
            <!--总览box-->
            <div class="clearfix">
              <el-row :gutter="5">
                <el-col :span="8">
                  <div class="car-box-list t0">
                    <span class="in-car-word text-center">Total Vehicle</span>
                    <span class="in-car-number text-center">{{totalVehicle}}</span>
                    <span class="in-car-word">
                      compare to last month
                      <svg-icon
                        :icon-class="this.totalVehiclelm > 0?'icon-jt-slode':'icon-jt-down'"
                      />
                      {{totalVehiclelm!=0?totalVehiclelm+"%":' '}}
                    </span>
                    <span class="in-car-word">
                      compare to last 3 month
                      <svg-icon
                        :icon-class="this.totalVehicleltm > 0?'icon-jt-slode':'icon-jt-down'"
                      />
                      {{totalVehicleltm!=0?totalVehicleltm+"%":''}}
                    </span>
                  </div>
                </el-col>
                <el-col type="flex" :span="8">
                  <div class="car-box-list t1">
                    <span class="in-car-word text-center">Total Mileage</span>
                    <span class="in-car-number text-center">
                      {{totalMileage}}
                      <span class="text-unit">km</span>
                    </span>
                    <span class="in-car-word">
                      compare to last month
                      <svg-icon
                        :icon-class="this.totalMileagelm > 0?'icon-jt-slode':'icon-jt-down'"
                      />
                      {{totalMileagelm!=0?totalMileagelm+"%":' '}}
                    </span>
                    <span class="in-car-word">
                      compare to last 3 month
                      <svg-icon
                        :icon-class="this.totalMileageltm > 0?'icon-jt-slode':'icon-jt-down'"
                      />
                      {{totalMileageltm!=0?totalMileageltm+"%":''}}
                    </span>
                  </div>
                </el-col>
                <el-col type="flex" :span="8">
                  <div class="car-box-list t2">
                    <span class="in-car-word text-center">Total Fuel Total Consumption</span>
                    <span class="in-car-number text-center">
                      {{totalFuel}}
                      <span class="text-unit">L</span>
                    </span>
                    <span class="in-car-word">
                      compare to last month
                      <svg-icon :icon-class="this.totalFuellm > 0?'icon-jt-slode':'icon-jt-down'" />
                      {{totalFuellm!=0?totalFuellm+"%":' '}}
                    </span>
                    <span class="in-car-word">
                      compare to last 3 month
                      <svg-icon :icon-class="this.totalFuelltm > 0?'icon-jt-slode':'icon-jt-down'" />
                      {{totalFuelltm!=0?totalFuelltm+"%":' '}}
                    </span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="5">
                <el-col type="flex" :span="8">
                  <div class="car-box-list t3">
                    <span class="in-car-word text-center">Total Trip</span>
                    <span class="in-car-number text-center">{{totalTrip}}</span>
                    <span class="in-car-word">
                      compare to last month
                      <svg-icon :icon-class="this.totalTriplm > 0?'icon-jt-slode':'icon-jt-down'" />
                      {{totalTriplm!=0?totalTriplm+"%":' '}}
                    </span>
                    <span class="in-car-word">
                      compare to last 3 month
                      <svg-icon :icon-class="this.totalTripltm > 0?'icon-jt-slode':'icon-jt-down'" />
                      {{totalTripltm!=0?totalTripltm+"%":' '}}
                    </span>
                  </div>
                </el-col>
                <el-col type="flex" :span="8">
                  <div class="car-box-list t4">
                    <span class="in-car-word text-center">Avg Mileage per car</span>
                    <span class="in-car-number text-center">
                      {{avgMileage}}
                      <span class="text-unit">km</span>
                    </span>
                    <span class="in-car-word">
                      compare to last month
                      <svg-icon :icon-class="this.avgMileagelm > 0?'icon-jt-slode':'icon-jt-down'" />
                      {{avgMileagelm!=0?avgMileagelm+"%":' '}}
                    </span>
                    <span class="in-car-word">
                      compare to last 3 month
                      <svg-icon
                        :icon-class="this.avgMileageltm > 0?'icon-jt-slode':'icon-jt-down'"
                      />
                      {{avgMileageltm!=0?avgMileageltm+"%":' '}}
                    </span>
                  </div>
                </el-col>
                <el-col type="flex" :span="8">
                  <div class="car-box-list t5">
                    <span class="in-car-word text-center">Avg Fuel Consumption per car</span>
                    <span class="in-car-number text-center">
                      {{avgFuel}}
                      <span class="text-unit">km/L</span>
                    </span>
                    <span class="in-car-word">
                      compare to last month
                      <svg-icon :icon-class="this.avgFuellm > 0?'icon-jt-slode':'icon-jt-down'" />
                      {{avgFuellm!=0?avgFuellm+"%":' '}}
                    </span>
                    <span class="in-car-word">
                      compare to last 3 month
                      <svg-icon :icon-class="this.avgFuelltm > 0?'icon-jt-slode':'icon-jt-down'" />
                      {{avgFuelltm!=0?avgFuelltm+"%":" "}}
                    </span>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!--Top5 mileage、obd fault、avg drving score-->
            <el-row class="home-rightbottom" :gutter="15">
              <el-col :span="8">
                <div class="home-echarts-list">
                  <h3 class="echarts-title">
                    <svg-icon icon-class="home-car" :style="{color:'498BFF'}" />Top 5 Mileage
                  </h3>
                  <div ref="topFiveMileage" class="echarts-box" />
                </div>
              </el-col>
              <el-col :span="8">
                <div class="home-echarts-list">
                  <h3 class="echarts-title">
                    <svg-icon icon-class="home-car" :style="{color:'39B8FF'}" />Top 5 OBD Fault
                  </h3>
                  <div ref="topFiveOBDfault" class="echarts-box" />
                </div>
              </el-col>
              <el-col :span="8">
                <div class="home-echarts-list">
                  <h3 class="echarts-title">
                    <svg-icon icon-class="home-car" :style="{color:'61d574'}" />Avg Driving Score
                  </h3>
                  <div ref="avgDrivingScore" class="echarts-box" />
                </div>
              </el-col>
            </el-row>
            <!--Top5 harsh turn、accel decele-->
            <el-row :gutter="15" class="home-rightbottom">
              <el-col :span="8">
                <div class="home-echarts-list">
                  <h3 class="echarts-title">
                    <svg-icon icon-class="home-car" :style="{color:'8976fd'}" />Top 5 Harsh Turn
                  </h3>
                  <div ref="topFiveHarshTurn" class="echarts-box" />
                </div>
              </el-col>

              <el-col :span="8">
                <div class="home-echarts-list">
                  <h3 class="echarts-title">
                    <svg-icon icon-class="home-car" :style="{color:'ff846f'}" />Top 5 Harsh Accel
                  </h3>
                  <div ref="topFiveHarshAccel" class="echarts-box" />
                </div>
              </el-col>
              <el-col :span="8">
                <div class="home-echarts-list">
                  <h3 class="echarts-title">
                    <svg-icon icon-class="home-car" :style="{color:'ffba36'}" />Top 5 Harsh Decel
                  </h3>
                  <div ref="topFiveHarshDecel" class="echarts-box" />
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>
// import { MapManager } from '@vue-map/google';
import { getUserLanguage } from "@/utils/auth"
import interval from "@/mixins/interval"
import MarkerClusterer from "@google/markerclustererplus"
import CarInfo from "./components/car-info"
import { mapState } from "vuex"
import {
  lineCharts,
  barCharts
} from "@/utils/eCharts"
import {
  getAllGps,
  getStatisticsCount,
  getMileageTop,
  getFaultTop,
  getAvgScoreTop,
  getHarshAccelerationTop,
  getHarshTurnTop,
  getHarshDecelerationTop,
  getMaxSpeed,
  setMaxSpeed
} from "@/api/home"
import {debounce} from 'throttle-debounce'
const iconPath = 'M38.8,47.9c0,1.3,0.1,2.8,0.3,4.5c0.2,1.7,0.4,3.1,0.7,4.5c0-1.3-0.1-2.8-0.3-4.5C39.2,50.7,39,49.3,38.8,47.9 c0.2-0.6,0.2-1.5,0-1.9c-0.1-0.6-0.3-1.1-0.7-1.6c-0.1-0.1-0.2-0.3-0.3-0.4l-0.4-0.4l-0.2,0.6c-0.9,0.7-5.6,1.1-7.1,1.1 c-1.5,0-6.3-0.7-7.1-1.1l-0.2-0.6l-0.4,0.6c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.4-0.6,1-0.7,1.6c-0.1,0.4,0,1.8,0.3,2.1 c0.8,1.1,1.7,1.3,2.9,1.7c1.6,0.4,3.9,0.4,5.6,0.4c1.7,0,3.8,0,5.5-0.4c1.2-0.3,2.3-0.7,3.1-1.7C38.7,48.1,38.8,48,38.8,47.9 L38.8,47.9z M18.6,19.3L18.5,18h-0.3c-0.1,0-0.2-0.1-0.2-0.2V9.9c0-0.1,0.1-0.2,0.2-0.2h0.2V7.9c0-0.6,0.4-1.7,1.2-2.8 c0.4-0.8,1-1.5,1.3-1.9C21.7,2.3,23.7,0,25,0l10.2,0c0.6,0,1.3,0.4,2,1c0.3,0,0.8,0.2,0.9,0.6c0.6,0.4,1,1,1.5,1.6 c0.4,0.4,1.3,1.8,1.3,2.6c0.4,0.8,0.8,1.7,0.8,2.2v2h0.2c0.1,0,0.2,0.1,0.2,0.2V18c0,0.1-0.1,0.2-0.2,0.2h-0.3v1.2 c1.3,0.3,2.7,0.4,2.2,1.7c-0.8-0.2-1.5-0.3-2.2-0.6L41,45h0.3c0.1,0,0.2,0.1,0.2,0.2V53c0,0.1-0.1,0.2-0.2,0.2h-0.4v1.3 c0,1.5-0.9,2.6-2.3,3.5c-5.2,3.4-19,2.3-19.1-3.1v-1.7h-0.6c-0.1,0-0.2-0.1-0.2-0.2v-7.8c0-0.1,0.1-0.2,0.2-0.2h0.3l-0.6-24.6 c-0.9,0.2-1.7,0.4-2.5,0.7C15.7,19.8,17.1,19.8,18.6,19.3L18.6,19.3z M40.2,20.1c0-0.1,0.1-0.3,0.1-0.4c-0.8,1-1.6,4-1.8,8.6v5.5 c0.4-0.1,1.6-0.2,1.6-0.8c0-4.4,0.1-8.4,0.2-12.7C40.3,20.2,40.2,20.2,40.2,20.1z M19.2,5.6c-0.1-0.8,0.9-2.2,1.3-2.8 c0.3-0.6,0.9-1.1,1.5-1.6c0.2-0.1,0.7-0.4,1-0.3l-0.2,0.2c-0.8,0.8-1.5,1.7-1.9,2.1c-0.4,0.6-1,1.3-1.6,2.2V5.4 C19.2,5.5,19.2,5.6,19.2,5.6z M39.9,43.4c0.1-3.1,0.2-5.9,0.1-9.3c-0.1-0.2-1.1,0.2-1.6,0.3v8.6C38.9,43.3,39.6,43.7,39.9,43.4 L39.9,43.4z M21.5,43.1v-8.6c-0.3-0.2-1.5-0.7-1.6-0.3c0.1,3.2,0.1,6,0.2,9.3C20.5,43.7,21.1,43.3,21.5,43.1z M21.5,33.7v-5.5 c-0.1-4.7-1-7.8-1.8-8.6c0.1,4.5,0.2,8.7,0.3,13.3C20,33.4,21.1,33.6,21.5,33.7z M39.3,17v-0.3c-5.9-1.9-11.8-2-17.8,0 c-0.2,0.1-0.3,0.3-0.3,0.6c0.3,2.6,0.8,4.5,1.2,7.1c0,0.1,0.1,0.1,0.1,0.2h0.1c4.9-0.9,9.9-0.9,14.9,0c0.1,0,0.2,0,0.3-0.1 s0.2-0.2,0.2-0.3C38.6,21.4,38.9,19.5,39.3,17z M25.2,8.7c0.2,2,0.4,3.9,0.7,5.5c0-1.7-0.1-3.5-0.3-5.5c-0.2-2-0.4-3.9-0.7-5.5 C24.8,4.8,24.9,6.7,25.2,8.7z M34.7,8.7c-0.2,2-0.3,3.9-0.3,5.5c0.2-1.7,0.4-3.5,0.7-5.5s0.3-3.9,0.3-5.5 C35.1,4.8,34.9,6.7,34.7,8.7z M20.8,52.4c0.2-1.7,0.3-3.1,0.3-4.5c-0.2,1.3-0.4,2.8-0.7,4.5c-0.2,1.7-0.3,3.1-0.3,4.5 C20.4,55.5,20.7,53.9,20.8,52.4z'
const colors = [
  '#d6d6d6',
  '#52d98f',
  '#ff5764',
  '#fcdd5e'
]
const urls = [
  require("@/assets/car_h.png"),
  require("@/assets/car_l.png"),
  require("@/assets/car_r.png"),
  require("@/assets/car_y.png")
]
const ms = [
  require("@/assets/m1.png"),
  require("@/assets/m2.png"),
  require("@/assets/m3.png"),
  require("@/assets/m4.png"),
  require("@/assets/m5.png")
]
export default {
  name: "home",
  components: { CarInfo },
  mixins: [interval],
  props: {
    positionId: [String, Number]
  },
  data() {
    return {
      debounce: 50,
      language: getUserLanguage(),
      urls,
      center: [100.530449, 13.722944],
      zoom: 13,
      carid: null,
      data: [],
      infoWindowPosition: null,
      vehicleInfoWindowOffset: [0, -20],
      visible: false,
      clusterer: null,
      mapEvents: {
        init: map => {
          this.clusterer = new MarkerClusterer(map, [], {
            ignoreHidden: true,
            styles: [
              {
                url: ms[0],
                width: 52,
                height: 52,
                // [y, x]
                anchorText: [20, 0]
              },
              {
                url: ms[1],
                width: 56,
                height: 56,
                anchorText: [22, 0]
              },
              {
                url: ms[2],
                width: 66,
                height: 66,
                anchorText: [27, 0]
              },
              {
                url: ms[3],
                width: 78,
                height: 78,
                anchorText: [33, 0]
              },
              {
                url: ms[4],
                width: 90,
                height: 90,
                anchorText: [40, 0]
              }
            ],
            clusterClass: "custom-clustericon"
          })
          this.handleMapReady()
        }
      },
      vehicleMarkerEvents: {
        init: m => {
          // this.clusterer.addMarker(m, true);
          this.clusterer.addMarker(m, true)
          this.debouncedRedraw()

        },
        destroyed: m => {
          // this.clusterer.removeMarker(m, true);
          this.clusterer.removeMarker(m, true)
          this.debouncedRepaint()

        },
        click: (marker, vueMarker) => {
          this.handleMarkerClick(vueMarker.$attrs.vehicle)
        }
      },
      speedVisible: false,
      tempSpeed: 60,
      maxSpeed: 60,
      interval: 30 * 1000,
      timeout: null,
      totalVehicle: "",
      totalVehiclelm: "",
      totalVehicleltm: "",
      totalMileage: "",
      totalMileagelm: "",
      totalMileageltm: "",
      totalFuel: "",
      totalFuellm: "",
      totalFuelltm: "",
      totalTrip: "",
      totalTriplm: "",
      totalTripltm: "",
      avgMileage: "",
      avgMileagelm: "",
      avgMileageltm: "",
      avgFuel: "",
      avgFuellm: "",
      avgFuelltm: ""
      // vehicleStatus:{
      //   normalspeed: 0,
      // parkingEngineOff: 0,
      // parkingEngineOn: 0,
      // overSpeed: 0
      // }
    }
  },
  computed: {
    vehicles() {
      const { maxSpeed } = this
      let data = this.data
      return data.map(v => {
        const lng = +(v.lng || 0)
        const lat = +(v.lat || 0)
        let status = 0
        //0 灰色 1 绿色 2 红色 3黄色
        if (v.speed > 0 && v.online == 1) {
          //在线，m.driving不等于0且小于设置的最大车速,则为正常车速
         
          status = 1
          //在线gpsspeed大于设置最大车速，则为超速
          if (maxSpeed != null && maxSpeed != 0 && v.speed > maxSpeed) {
            status = 2
          }
        }
        //如果转速rpm大于0，则为停车未熄火否则就为停车熄火状态
        else if (v.rpm > 0 && v.online == 1) {
          status = 3
        }
        //如果无转速,不在线，则为离线
        else {
          status = 0
        }
        return {
          /*   转速>0 & 车速=0    :  Engine On（Stop）
              转速=0                     :  Engine Off
              转速>0 & 车速>0 & 车速<maxSpeed  : Normal Speed
              转速>0 & 车速>maxSpeed  : Over Speed */
          status: status,
          position: [lng, lat],
          id: v.carId,
          visible: lng != 0 && lat != 0,
          icon: {
            anchor: { x: 30, y: 30},
            path: iconPath,
            fillColor: colors[status],
            fillOpacity: 1,
            scale: 0.6,
            rotation: v.direction
          }
        }
      })
    },
    vehicleStatus() {
      const { maxSpeed } = this
      let data = this.data
      var normalspeed = 0,
        parkingEngineOff = 0,
        parkingEngineOn = 0,
        overSpeed = 0
      data.map(m => {
        //计算normalspeed parkingEngineOff parkingEngineOn overSpeed
        // m.driving!=0?m.gpsSpeed>this.maxSpeed?overSpeed++:normalspeed++:m.online?parkingEngineOn++:parkingEngineOff++
        if (m.speed > 0 && m.online == 1) {
          //在线，m.driving不等于0且小于设置的最大车速,则为正常车速
          if (m.speed < maxSpeed) {
            normalspeed++
          }
          //在线gpsspeed大于设置最大车速，则为超速
          if (m.speed > maxSpeed) {
            overSpeed++
          }
        }
        //如果转速rpm大于0，则为停车未熄火否则就为停车熄火状态
        else if (m.rpm > 0 && m.online == 1) {
          parkingEngineOn++
        } else {
          parkingEngineOff++
        }
      })
      return {
        normalspeed: normalspeed,
        parkingEngineOff: parkingEngineOff,
        parkingEngineOn: parkingEngineOn,
        overSpeed: overSpeed
      }
    },
    ...mapState("theme", ["color", "activeName"])
  },
  watch: {
    positionId(newVal) {
      this.find(newVal)
    }
  },
  mounted() {
    this.themeColor = this.color
    this._getMaxSpeed()
    if (this.activeName === "block") {
      this.themeColor = "#66b1ff"
    }
    this.topFiveMileage(this.getLineargradient("#498bff", "#cddfff"))
    this.topFiveOBDfault(this.getLineargradient("#39b8ff", "#ccf9ff"))
    this.avgDrivingScore(this.getLineargradient("#61D574", "#ffffff"))
    this.topFiveHarshTurn(this.getLineargradient("#8976fd", "#d0d6ff"))
    this.topFiveHarshAccel(this.getLineargradient("#ff846f", "#ffe2d8"))
    this.topFiveHarshDecel(this.getLineargradient("#ffba36", "#ffeabd"))
    this.totalCount()
  },
  created() {
    this.debouncedRepaint = debounce(this.debounce, () => {
      this.repaint()
    })
    this.debouncedRedraw = debounce(this.debounce, () => {
      this.redraw()
    })
    
  },
  methods: {
    _getMaxSpeed(){
      getMaxSpeed().then(({data})=>{
        if(data.code===0){
          this.tempSpeed = data.data
          window.localStorage.removeItem('tempSpeed')
          localStorage.setItem("tempSpeed",this.tempSpeed)
          this.maxSpeed = this.tempSpeed
        }
      })
    },
    changeSpeed(){
      const postData = {
        maxSpeed:this.tempSpeed
      }
      setMaxSpeed(postData).then(({data})=>{
        if(data.code===0){
          this.$message.success({
            message: this.$t('public.updateSuccess'),
            duration: 2 * 1000
          })
        }
      })
      window.localStorage.removeItem('tempSpeed')
      localStorage.setItem("tempSpeed",this.tempSpeed)
    },
    /*  reset(){
      this.normalspeed=0,
      this.parkingEngineOff=0,
      this.parkingEngineOn=0,
      this.overSpeed=0
    }, */
    handleMapReady() {
      this.doRefresh()
    },
    redraw() {
      if (this.clusterer) {
        this.clusterer.redraw_()
      }
    },
    repaint() {
      if (this.clusterer) {
        this.clusterer.repaint()
      }
    },
    refresh() {
      return this.getVehicleGps()
    },
    getVehicleGps() {
      const promise = getAllGps()
      promise.then(resp => {        
        if (!resp.data.data) {
          console.log("Interface return null GPS data ！")
          return
        }
        if (resp.data.data.length > 0) {
          this.data = resp.data.data
          if (this.visible) {
            const current = this.data.filter(v => v.carId == this.carid)[0]
            this.infoWindowPosition = [
              +(current.lng || 0),
              +(current.lat || 0)
            ]
          }
        }
        /*bus.$emit('online-refresh', resp.data.filter(v => v.online).map(v => v.carId)) */
      })
      return promise
    },
    handleMarkerClick(v) {
      this.carid = v.id
      this.infoWindowPosition = v.position
      this.visible = true
    },
    /*   handleSingleMonitor(id) {
      this.$emit('single-monitor', id)
    }, */
    find(id) {
      const vehicle = this.vehicles.filter(v => v.id == id)[0]
      if (vehicle) {
        this.center = vehicle.position
        this.zoom = 18
        // 如果有定位就自动打开小窗口
        if (vehicle.position[0] !== 0 && vehicle.position[1] !== 0) {
          window.setTimeout(() => {
            this.handleMarkerClick(vehicle)
          }, 10)
        }
      }
    },
    //对比上月 • (this month to date) / last month) * 100
    compareToLastMonth(arr, key, n) {
      let val1 = arr[0][key] || 0
      let val2 = arr[1] ? (arr[1][key] ? arr[1][key] : 0) : 0
      let resVal = val2 == 0 ? 0 : (val1 / val2) * 100
      const result = Number.parseFloat(resVal).toFixed(n)      
      return result
    },
    //对比上季度(this month to date) /  ((last month + last 2 month + last 3 month) / 3)) * 100
    compareToLast3Month(arr, key, n) {
      const val1 = arr[0][key] || 0
      const val2 = arr[1] ? (arr[1][key] ? arr[1][key] : 0) : 0
      const val3 = arr[2] ? (arr[2][key] ? arr[2][key] : 0) : 0
      const val4 = arr[3] ? (arr[3][key] ? arr[3][key] : 0) : 0
      let resVal =
        val2 + val3 + val4 == 0 ? 0 : val1 / ((val2 + val3 + val4) / 3)
      const result = Number.parseFloat(resVal).toFixed(n)
      return result
    },
    //获取总览统计数据
    totalCount() {
      getStatisticsCount().then(({ data }) => {
        if (data.code === 0) {
          this.totalVehicle = data.data[0].carCount
          this.totalVehiclelm = this.compareToLastMonth(
            data.data,
            "carCount",
            2
          )
          this.totalVehicleltm = this.compareToLast3Month(
            data.data,
            "carCount",
            2
          )
          this.totalMileage = data.data[0].mileageTotal
          this.totalMileagelm = this.compareToLastMonth(
            data.data,
            "mileageTotal",
            2
          )
          this.totalMileageltm = this.compareToLast3Month(
            data.data,
            "mileageTotal",
            2
          )
          this.totalFuel = data.data[0].oilTotal
          this.totalFuellm = this.compareToLastMonth(data.data, "oilTotal", 2)
          this.totalFuelltm = this.compareToLast3Month(
            data.data,
            "oilTotal",
            2
          )
          this.totalTrip = data.data[0].tripCount
          this.totalTriplm = this.compareToLastMonth(data.data, "tripCount", 2)
          this.totalTripltm = this.compareToLast3Month(
            data.data,
            "tripCount",
            2
          )
          this.avgMileage = data.data[0].avgMileage
          this.avgMileagelm = this.compareToLastMonth(
            data.data,
            "avgMileage",
            2
          )
          this.avgMileageltm = this.compareToLast3Month(
            data.data,
            "avgMileage",
            2
          )
          this.avgFuel = data.data[0].avgOil
          this.avgFuellm = this.compareToLastMonth(data.data, "avgOil", 2)
          this.avgFuelltm = this.compareToLast3Month(data.data, "avgOil", 2)
        }
      })
    },
    // top5里程柱状图
    topFiveMileage(color) {
      this.initBar(color, this.$refs.topFiveMileage, "bar", "getMileageTop")
    },
    topFiveOBDfault(color) {
      this.initBar(color, this.$refs.topFiveOBDfault, "bar", "getFaultTop")
    },
    avgDrivingScore(color) {
      this.initBar(color, this.$refs.avgDrivingScore, "line", "getAvgScoreTop")
    },
    topFiveHarshTurn(color) {
      this.initBar(
        color,
        this.$refs.topFiveHarshTurn,
        "bar",
        "getHarshTurnTop"
      )
    },
    topFiveHarshAccel(color) {
      this.initBar(
        color,
        this.$refs.topFiveHarshAccel,
        "bar",
        "getHarshAccelerationTop"
      )
    },
    topFiveHarshDecel(color) {
      this.initBar(
        color,
        this.$refs.topFiveHarshDecel,
        "bar",
        "getHarshDecelerationTop"
      )
    },
    initBar(color, ref, barType, datasource) {
      let promise
      switch (datasource) {
        case "getMileageTop":
          promise = getMileageTop()
          break
        case "getFaultTop":
          promise = getFaultTop()
          break
        case "getAvgScoreTop":
          promise = getAvgScoreTop()
          break
        case "getHarshTurnTop":
          promise = getHarshTurnTop()
          break
        case "getHarshAccelerationTop":
          promise = getHarshAccelerationTop()
          break
        case "getHarshDecelerationTop":
          promise = getHarshDecelerationTop()
          break
        default:
          break
      }

      if (promise === undefined || promise === null) {
        return
      }
      promise.then(({ data }) => {
        const xdata = []
        const chartsdata = []
        if (data.code === 0) {
          (data.data || []).forEach(element => {
            xdata.push(Object.values(element)[0])
            chartsdata.push(Object.values(element)[1])
          })
          const myChart = this.$echarts.init(ref)
          myChart.clear()
          let optionData
          switch (barType) {
            case "bar":
              optionData = barCharts(color, xdata, chartsdata)
              break
            case "line":
              optionData = lineCharts(color, xdata, chartsdata)
              break
            default:
              break
          }
          if (optionData === undefined || optionData === null) return
          myChart.setOption(optionData)
        }
      })
    },
    getLineargradient(color1, color2) {
      return {
        type: "linear",
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          {
            offset: 0,
            color: color1 // 0% 处的颜色
          },
          {
            offset: 1,
            color: color2 // 100% 处的颜色
          }
        ],
        globalCoord: false // 缺省为 false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-box {
  padding: 10px;
}
.home-echarts-list {
  /* float:left; */
  width: 100%;
  /* padding: 10px; */
  box-sizing: border-box;
  box-shadow: 2px 2px 5px #687c92;
  /*  margin-left:15px;
  margin: 15px; */
}
.home-rightbottom {
  border-radius: 6px;
}
.echarts-title {
  height: 30px;
  line-height: 30px;
  margin-left: 5px;
}
.echarts-box {
  height: 200px;
}
.map-car-list {
  border-radius: 6px;
  margin: 5px;
  height: 90px;
  color: #fff;
  padding: 5px;
  position: relative;
  box-shadow: 2px 2px 5px #687c92;
  .list-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.car-box-list {
  border-radius: 6px;
  margin: 5px;
  height: 90px;
  color: #fff;
  padding: 5px;
  position: relative;
  box-shadow: 2px 2px 5px #687c92;
}
.car-box-list2 {
  height: 170px;
}
.car-box-list img {
  position: absolute;
  right: 0;
  bottom: 10px;
}
.l1 {
  background: no-repeat url(../../assets/k_1.png);
  background-size: cover;
}
.t0 {
  background-image: url(../../assets/k_totalvehicle.png);
  background-size: cover;
}
.t1 {
  background-image: url(../../assets/k_totalmileage.png);
  background-size: cover;
}
.t2 {
  background-image: url(../../assets/k_totalfuel.png);
  background-size: cover;
}
.t3 {
  background-image: url(../../assets/k_totaltrip.png);
  background-size: cover;
}
.t4 {
  background-image: url(../../assets/k_avgmileage.png);
  background-size: cover;
}
.t5 {
  background-image: url(../../assets/k_avgfuel.png);
  background-size: cover;
}
.in-car-word {
  display: block;
  font-size: 12px !important;
}
.in-car-number {
  display: block;
  font-size: 20px !important;
  margin: 5px 0;
}
.text-unit {
  display: contents;
  font-size: 10px !important;
}
.map-tha {
  box-shadow: 2px 2px 5px #687c92;
  height: 607px;
  margin: 5px;
}
.text-center {
  display: flex;
  justify-content: center;
}
.img-center {
  width: 50px;
  height: 30px;
}
.over-speed {
  position: absolute;
  top: 10px;
  right: 10px;
  .el-button {
    width: 36px;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
